import { useQuery, useQueryClient } from "@tanstack/react-query";
import { APIHandlerV1 } from "hooks/api-handler-v1";
import { APIHandlerV2 } from "hooks/api-handler-v2";
import { useEffect } from "react";

// default stale time and cache time settings
const DEFAULT_STALE_TIME = 30 * 60 * 1000; // in milliseconds
const DEFAULT_CACHE_TIME = 30 * 60 * 1000; // in milliseconds
//---------------------------//
export function useReactQueryV2({
  method,
  url,
  paramsData,
  isBioMechanics,
  isAbsoluteUrl,
  isOldBaseUrl = false,
  queryKey,
  skip = false,
  cacheTime = DEFAULT_CACHE_TIME,
  staleTime = DEFAULT_STALE_TIME,
  refetchOnMount,
  refetchOnWindowFocus,
  cache = true,
}) {
  const queryClient = useQueryClient();

  const query = useQuery({
    keepPreviousData: false,
    staleTime: cache ? staleTime : 1000,
    cacheTime: cache ? cacheTime : 1000,
    refetchOnWindowFocus: refetchOnWindowFocus || false,
    refetchOnMount: refetchOnMount || false,
    queryKey: queryKey,
    enabled: skip ? false : true,
    queryFn: async () => {
      const result = await APIHandlerV2({
        method,
        url,
        data: paramsData,
        isBioMechanics,
        isAbsoluteUrl,
        isOldBaseUrl,
      });
      return result;
    },
    onSuccess: (response) => {
      return response;
    },
    onError: (err) => {
      console.log("queryKey: ", queryKey, " Error: ", err);
    },
  });

  function inValidateQuery() {
    queryClient.invalidateQueries({ queryKey: queryKey });
  }

  return { ...query, inValidateQuery };
}
